document.addEventListener('turbolinks:load', function () {
    // if ($('#card-payment').length === 0) {
    if ($('.payments.show, .fee_payments.show').length === 0) {
        return false
    }

    var token = $("meta[name='csrf-token']").attr('content');
    var form = document.getElementById('payment-form');
    var paymentId = form.className
    var cardDetailField = document.getElementById('enter-card-details')
    var newCardButton = document.getElementById('new-card-button')
    var confirmPaymentBtn = document.querySelector('.confirm-payment-btn')
    var partialPaymentPage = form.dataset.partialPaymentPage === 'true'

    // Store stripe and elements in outer scope for form submission
    var stripe = null;
    var elements = null;
    var domainUrl = null;

    var page_type, payment_intent_url
    if ($('.fee_payments.show').length > 0) {
        page_type = 'fee_payment'
        payment_intent_url = `/fee_payments/${paymentId}/create_payment_intent`
    } else {
        page_type = 'stripe_payment'
        payment_intent_url = partialPaymentPage
            ? `/payments/${paymentId}/create_partial_payment_intent`
            : `/payments/${paymentId}/create_payment_intent`
    }

    $(document).on('change', ".payment-methods input[type='radio'], .new-method input[type='radio']", function () {
        let value = $(this).val()
        if ($(this).prop('checked') && value === "new_payment_method") {
            cardDetailField.classList.remove('d-none')
            if (!$('#payment-element').hasClass('StripeElement')) {
                initialize()
            }
        } else {
            cardDetailField.classList.add('d-none')
        }
    })

    if (newCardButton) {
        newCardButton.addEventListener('click', function(e) {
            e.preventDefault()
            var newMethodRadio = $('#new_card_method')
            if (newMethodRadio.length) {
                newMethodRadio.prop('checked', true).trigger('change')
            }
        })
    }

    if(confirmPaymentBtn) {
        confirmPaymentBtn.addEventListener('click', function(e) {
            form.requestSubmit();
        })
    }

    // Attach form submit handler at page load to prevent race condition
    form.addEventListener('submit', async function (event) {
        var confirmButton = $('.confirm-payment-btn')
        $(confirmButton).prop('disabled', true)

        // Check both possible radio button containers
        var radioButton = form.querySelector(".payment-methods input[type='radio']:checked, .new-method input[type='radio']:checked")
        var paymentMethodValue = radioButton ? radioButton.value : null

        if (paymentMethodValue === 'new_payment_method') {
            event.preventDefault();

            // Check if Stripe Elements are ready
            if (!stripe || !elements) {
                alert('Please wait for the card form to load before submitting.');
                $(confirmButton).prop('disabled', false)
                return;
            }

            var cardName = form.querySelector('#card_name').value
            var return_url = getReturnUrl(domainUrl)
            if (cardName.length > 0) {
                return_url = `${return_url}?name=${cardName}`
            }
            const {error} = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    return_url: return_url,
                }
            });

            if (error) {
                alert(error.message);
            }
        }
        $(confirmButton).prop('disabled', false)
    });

    function initialize() {
        $.ajax({
            url: "/payments/stripe_publishable_key",
            data: {
                authenticity_token: token
            },
            method: 'get'
        }).done(function (res) {
            if (res['error']) {
                alert(res['error'])
            } else {
                var key = res['key']
                createPaymentIntent(key)
            }
        }).fail(function (res) {
            alert('Something went wrong')
        });
    }

    function createPaymentIntent(publishable_key) {
        $.ajax({
            url: payment_intent_url,
            data: {
                authenticity_token: token
            },
            method: 'post'
        }).done(function (res) {
            if (res['error']) {
                alert(res['error'])
            } else {
                var clientSecret = res['client_secret']
                domainUrl = res['domain_url']
                var connectAccountId = res['connect_account_id']
                stripe = createStripeClient(publishable_key, connectAccountId)
                loadForm(clientSecret)
            }
        }).fail(function (res) {
            alert('Something went wrong')
        });
    }

    function createStripeClient(key, connectAccountId) {
        // Create a Stripe client.
        return Stripe(key, {stripeAccount: connectAccountId});
    }

    function loadForm(clientSecret) {
        // Create an instance of Elements.
        elements = stripe.elements({clientSecret});

        // Create an instance of the payment Element.
        var paymentElement = elements.create('payment');

        // Add an instance of the payment Element into the `payment-element` <div>.
        paymentElement.mount('#payment-element');
    }

    function getReturnUrl(domainUrl) {
        if (page_type === 'fee_payment') {
            return `${domainUrl}/fee_payments/${paymentId}/checkout`
        } else {
            return `${domainUrl}/payments/${paymentId}/checkout`
        }
    }
});